import { ComponentProps, ReactNode } from 'react'
import { OverlayDrawer } from '@molecules'
import { create } from 'zustand'

type GlobalDrawerState = Omit<ComponentProps<typeof OverlayDrawer>, 'name'> & {
    setDrawerState: (title: string, content: ReactNode, isOpen: boolean) => void
    closeDrawer: () => void
    title: string
    content: ReactNode
}

export const useGlobalDrawerStore = create<GlobalDrawerState>((set) => ({
    isOpen: false,
    title: '',
    content: '',
    setDrawerState: (title, content, isOpen) => {
        set({ title, content, isOpen })
    },
    closeDrawer: () => {
        set({ isOpen: false })
    },
}))
